export function hasId(val) {
    return typeof val === 'object' && val !== null && val.id !== undefined;
}
export function getId(val) {
    if (hasId(val)) {
        return val.id;
    }
    return val;
}
export function getOptionalId(val) {
    if (hasId(val)) {
        return val.id;
    }
    return val;
}
//# sourceMappingURL=Identifiable.js.map